import React from 'react';
import {Navigate, Outlet, useParams} from 'react-router-dom';
import availableLanguages from '../../utils/i18n/config/availableLanguages';

// Languages allowed as URL prefix: availableLanguages minus en (unprefixed) and zh (URLs use zh-cn / zh-tw)
const URL_LANGS = availableLanguages.filter(l => l !== 'en' && l !== 'zh');

export default function LangGuard() {
  const {lang} = useParams();
  if (!URL_LANGS.includes(lang)) return <Navigate to="/notfound" replace />;
  return <Outlet />;
}
